import script from "./CampaignEditInformations.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignEditInformations.vue?vue&type=script&setup=true&lang=js"

import "./CampaignEditInformations.vue?vue&type=style&index=0&id=fbe700f8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbe700f8"]])

export default __exports__